<template>
  <div>
    <div class="table-header row">
      <div>
        <input type="checkbox" v-model="isSelectAll" @change="selectAllChange" />
      </div>
      <div>账号</div>
      <div>姓名/角色</div>
      <div>手机</div>
      <div>邮箱</div>
      <div>状态</div>
      <div>安全中心客户端</div>
      <div>DLL注入和开机通道</div>
      <div>注册时间</div>
      <div>最后登录时间/登录IP</div>
      <div>管理范围</div>
      <div>权限</div>
      <div>备注</div>
      <div>操作</div>
    </div>
    <div class="table-body">
      <div class="row" v-for="(item, index) in emplyeeTableList" :key="index">
        <!-- 选中 -->
        <div>
          <input type="checkbox" v-model="item.select" @change="selectChange(item.select)" />
        </div>
        <!-- 账号 -->
        <div>
          <span v-text="item.passportName"></span>
        </div>
        <!-- 姓名/角色 -->
        <div class="name">
          <p v-text="item.personalName"></p>
          <p v-text="item.passportType"></p>
        </div>
        <!-- 手机 -->
        <div>
          <span v-text="item.passportPhone"></span>
        </div>
        <!-- 邮箱 -->
        <div>
          <span v-if="item.passportMail" v-text="item.passportMail" :title="item.passportMail"></span>
          <span v-if="!item.passportMail">-</span>
        </div>
        <!-- 状态 -->
        <div class="status">
          <hover-down style="margin-top:-20px;margin-left:50px" :visible="visible">
            <div slot="hoverBtn" style="margin-top:20px;height:15px" @mouseover="visible = true">
              <span v-if="!item.passportState" class="activate">激活</span>
              <span v-if="item.passportState" class="freeze">冻结</span>
              <img src="@/assets/img/icon/u231.png" alt="" />
            </div>
            <div slot="down">
              <div class="drop-row" @click="selDropdownItem(0, item.passportName)">
                <span>激活</span>
              </div>
              <div class="drop-row" @click="selDropdownItem(1, item.passportName)">
                <span>冻结</span>
              </div>
            </div>
          </hover-down>
        </div>
        <!-- 安全中心客户端下载 -->
        <div class="status">
          <template v-if="item.passportType !='业主'">
            <hover-down style="margin-top:-20px;margin-left:50px" :visible="visible">
              <div slot="hoverBtn" style="margin-top:20px;height:15px" @mouseover="visible = true">
                <span v-if="item.safeCenterFlag" class="activate">允许下载</span>
                <span v-if="!item.safeCenterFlag" class="freeze">禁止下载</span>
                <img src="@/assets/img/icon/u231.png" alt="" />
              </div>
              <div slot="down">
                <div class="drop-row" v-if="!item.safeCenterFlag" @click="switchSafeCenter(1, item.passportName)">
                  <span>允许下载</span>
                </div>
                <div class="drop-row" v-if="item.safeCenterFlag" @click="switchSafeCenter(0, item.passportName)">
                  <span>禁止下载</span>
                </div>
              </div>
            </hover-down>
          </template>
          <template v-else>
            <div style="margin-top:14px;line-height:20px">
              <span v-if="item.safeCenterFlag" class="activate">允许下载</span>
              <span v-if="!item.safeCenterFlag" class="freeze">禁止下载</span>
            </div>
          </template>
        </div>
        <div class="status">
          <template v-if="item.passportType !='业主'">
            <hover-down style="margin-top:-20px;margin-left:50px" :visible="visible">
              <div slot="hoverBtn" style="margin-top:20px;height:15px" @mouseover="visible = true">
                <span v-if="item.dllFlag" class="activate">允许使用</span>
                <span v-if="!item.dllFlag" class="freeze">禁止使用</span>
                <img src="@/assets/img/icon/u231.png" alt="" />
              </div>
              <div slot="down">
                <div class="drop-row" v-if="!item.dllFlag" @click="switchDllFlag(1, item.passportName)">
                  <span>允许使用</span>
                </div>
                <div class="drop-row" v-if="item.dllFlag" @click="switchDllFlag(0, item.passportName)">
                  <span>禁止使用</span>
                </div>
              </div>
            </hover-down>
          </template>
          <template v-else>
            <div style="margin-top:14px;line-height:20px">
              <span v-if="item.safeCenterFlag" class="activate">允许下载</span>
              <span v-if="!item.safeCenterFlag" class="freeze">禁止下载</span>
            </div>
          </template>
        </div>
        <!-- 注册时间 -->
        <div>
          <span v-text="item.registerTime"></span>
        </div>
        <!-- 最后登录时间/登录IP -->
        <div class="login-time-ip">
          <p v-text="item.lastLoginTime"></p>
          <p v-text="item.lastLoginIP"></p>
        </div>
        <!-- 管理范围 -->
        <div>
          <span v-text="item.managementDomainList.join('、')" :title="item.managementDomainList.join('、')"></span>
        </div>
        <!-- 权限 -->
        <div>
          <span v-text="item.authorityList.join('、')" :title="item.authorityList.join('、')"></span>
        </div>
        <!-- 备注 -->
        <div class="remarks" @mouseover="changeActive(index)" @mouseout="removeActive()">
          <a href="#" @click.prevent="showInput($event, index)" v-show="seen && index == current"><img
              src="@/assets/img/icon/u2910.png" alt="" @click="inputFocus(index)" /></a>
          <input type="text" class="mark-input" ref="markInput" v-model="item.remark" @keyup.enter="changeRemark(item)"
            @blur="changeRemark(item)" v-show="item.remark || index == present" :title="item.remark" />
        </div>
        <div class="operation">
          <a href="#" @click.prevent="edit(item)">修改</a>
          <a @click.prevent="delItem(item.passportName)">删除</a>
        </div>
      </div>
      <no-data style="height:auto;padding-top:20px;padding-bottom:20px;"
        v-show="emplyeeTableList.length == 0 || loading" :nodata="emplyeeTableList.length == 0 && !loading"
        :loading="loading"></no-data>
    </div>
    <div class="deleteAll" v-if="emplyeeTableList.length > 0">
      <input type="checkbox" v-model="isSelectAll" @change="selectAllChange" />
      <a href="#" class="default-btn" @click.prevent="delAll()">删除</a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
// 更多悬浮
import HoverDown from '_c/dropdown/hoverDown';
import { _status, _remark, switchSafeCenter, switchDllFlag } from '@/requests/emplyee';
import NoData from '_c/noData/noData';
import httpApi from '@/apis/httpApi';
export default {
  name: 'emplyee-table',
  components: {
    HoverDown,
    NoData
  },
  props: {
    tableList: {
      type: Array,
      default () {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    tablePage: {
      type: Number
    }
  },
  data () {
    return {
      isSelectAll: false,
      emplyeeTableList: [],
      seen: false,
      appear: false,
      current: 0,
      present: 0,
      visible: false
      // active: 0,
    };
  },
  computed: {
    ...mapState({
      active: state => state.emplyee.active,
      saveType: state => state.user.userInfo.saveType
    })
  },
  watch: {
    saveType () {
      this['emplyee/actionSetActive'](this.saveType);
    },
    tableList () {
      this.isSelectAll = false;
      this.emplyeeTableList = this.tableList.map(item => {
        let authorityList = [];

        let managementDomainList = [];
        if (item.passportPermissionList) {
          item.passportPermissionList.forEach(item => {
            if (item.productId == 1) {
              switch (item.permValue) {
                case 0:
                  item.permValue = '';
                  break;
                case 1:
                  item.permValue = '注册网吧ID';
                  break;
                case 2:
                  item.permValue = '修改网吧资料';
                  break;
                case 3:
                  item.permValue = '注册网吧ID、修改网吧资料';
                  break;
                default:
                  break;
              }
            }
            if (item.productId == 10000) {
              switch (item.permValue) {
                case 0:
                  item.permValue = '';
                  break;
                case 1:
                  item.permValue = '远程控制';
                  break;
                case 2:
                  item.permValue = '监控中心';
                  break;
                case 3:
                  item.permValue = '远程控制、监控中心';
                  break;
                default:
                  break;
              }
            }
            if (item.permValue) {
              authorityList.push(item.permValue);
            }
          });
        } else {
          authorityList = [];
        }
        if (authorityList.length > 0) {
          item.authorityList = authorityList;
        } else {
          item.authorityList = ['未分配权限'];
        }
        if (item.barGroupPermissionList) {
          if (item.passportType == 2) {
            item.barGroupPermissionList.forEach(item => {
              managementDomainList.push(item.groupName);
            });
          } else if (item.passportType == 3) {
            item.barGroupPermissionList.forEach(item => {
              managementDomainList.push(item.barName);
            });
          }
        } else {
          managementDomainList = [];
        }
        item.managementDomainList = managementDomainList;
        if (item.passportType == 2) {
          item.passportType = '员工';
        } else if (item.passportType == 3) {
          item.passportType = '业主';
        }
        if (item.remark) {
          this.appear = true;
        }
        item.select = false;
        return item;
      });
    }
  },
  methods: {
    ...mapActions([
      'emplyee/actionSetShowOrHide',
      'emplyee/actionSetShow',
      'emplyee/actionSetTitle',
      'emplyee/actionSetCheckList',
      'emplyee/actionSetVal',
      'emplyee/actionSetActive'
    ]),
    // 修改
    edit (item) {
      this['emplyee/actionSetShowOrHide'](true);
      this['emplyee/actionSetTitle']('修改');
      this['emplyee/actionSetCheckList'](item);
    },
    // 单条删除
    delItem (val) {
      this['emplyee/actionSetShow'](true);
      this['emplyee/actionSetVal'](val);
      this.$emit('del', val);
      this.$emit('pagechange', 1);
    },
    // 多条删除
    delAll () {
      let accountList = [];
      this.emplyeeTableList.forEach(item => {
        if (item.select) {
          accountList.push(item.passportName);
        }
      });
      if (accountList.length > 0) {
        this['emplyee/actionSetVal'](accountList.toString());
        this['emplyee/actionSetShow'](true);
      }
    },
    // 全选
    selectAllChange () {
      if (this.isSelectAll) {
        this.emplyeeTableList.forEach(item => {
          item.select = true;
        });
      } else {
        this.emplyeeTableList.forEach(item => {
          item.select = false;
        });
      }
    },
    selectChange (selectState) {
      if (selectState) {
        // 对单项进行选中
        // 判断是否全部选中
        let selectAllState = this.emplyeeTableList.every(item => {
          return item.select == true;
        });
        // 若全部选中,则为全选状态
        if (selectAllState) {
          this.isSelectAll = true;
        }
      } else {
        // 对单项进行取消
        this.isSelectAll = false;
      }
    },
    async selDropdownItem (val, account) {
      // 下拉框选择
      this.visible = false;
      let obj = {
        freezeState: val,
        passportName: account,
        smsCode: ''
      };
      let data = {
        url: httpApi.emplyee.status,
        data: obj
      };
      let res = await _status(obj);
      if (res.code == 401) {
        let res = await window.$sms.show(data);
        if (res) {
          this.$emit('dropList', this.tablePage);
        }
      }
      this.$emit('dropList', this.tablePage);
    },
    async changeRemark (val) {
      // 修改备注
      let obj = {
        remark: val.remark,
        passportName: val.passportName
      };
      let data = {
        url: httpApi.emplyee.mark,
        data: obj
      };
      let res = await _remark(obj);
      if (res.code == 401) {
        let res = await window.$sms.show(data);
        if (res) {
          this.$emit('mark', this.tablePage);
        }
      }
      this.$emit('mark', this.tablePage);
    },
    showInput (e, index) {
      this.seen = true;
      this.current = index;
      this.present = index;
    },
    changeActive (index) {
      this.seen = true;
      this.current = index;
    },
    removeActive () {
      this.seen = false;
      this.current = null;
    },
    inputFocus (i) {
      this.$nextTick(() => {
        this.$refs.markInput[i].focus();
      });
    },
    async switchDllFlag(val, passportName) {
      let res = await switchDllFlag({
        passportName: passportName,
        dllFlag: val
      })
      console.log(res)
      if (res.code == 200) {
        this.$emit('dropList', this.tablePage);
      } else {
        window.$Message.show({
          title: '提示',
          type: 'error',
          msg: res.msg,
        })
      }
    },
    async switchSafeCenter (val, passportName) {
      let res = await switchSafeCenter({
        passportName: passportName,
        safeCenterFlag: val
      })
      console.log(res)
      if (res.code == 200) {
        this.$emit('dropList', this.tablePage);
      } else {
        window.$Message.show({
          title: '提示',
          type: 'error',
          msg: res.msg,
        })
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "_style/_color.scss";
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";

.row {
  width: 100%;
  @include clearfix();

  &:after {
    content: "";
    top: 0;
    left: 0;
    display: block;
    font-size: 0;
    height: 0;
    width: 0;
    clear: both;
    visibility: hidden;
  }

  >div {
    float: left;
    text-align: left;
    text-overflow: ellipsis;
    height: 50px;

    span {
      @include ellipsis();
      display: inline-block;
      max-width: 100%;
    }

    p {
      @include ellipsis();
      max-width: 100%;
    }

    a {
      text-align: left;
      text-indent: 0px;
      margin-right: 8px;
      color: $blue;
    }

    input {
      cursor: pointer;
    }
  }

  >div:nth-child(1) {
    width: 3%;
    text-indent: 10px;

    input {
      position: relative;
      top: 2px;
    }
  }

  >div:nth-child(2) {
    width: 6%;
  }

  >div:nth-child(3) {
    width: 6%;
  }

  >div:nth-child(4) {
    width: 5%;
  }

  >div:nth-child(5) {
    width: 10%;
  }

  >div:nth-child(6) {
    width: 5%;
  }

  >div:nth-child(7) {
    width: 6%;
  }
  >div:nth-child(7) {
    width: 6%;
  }
  >div:nth-child(8) {
    width: 8%;
  }

  >div:nth-child(9) {
    width: 8%;
  }

  >div:nth-child(10) {
    width: 8%;
  }

  >div:nth-child(11) {
    width: 10%;
  }

  >div:nth-child(12) {
    width: 10%;
    text-align: center;
  }
}

.table-header {
  >div {
    height: 30px;
    line-height: 30px;
  }
}

.deleteAll {
  display: inline-block;
  float: left;
  padding: 20px 0px 20px 10px;

  a {
    width: 90px;
    height: 30px;
    padding: 0;
    line-height: 30px;
    text-align: center;
    margin-left: 20px;
  }
}

.name,
.login-time-ip {
  p {
    line-height: normal;
    line-height: 14px;
  }

  p:nth-child(1) {
    padding-top: 10px;
  }

  p:nth-child(2) {
    color: #a1a1a1;
  }
}

.status {
  position: relative;
  cursor: pointer;

  .more-btn {
    margin-left: 0 !important;

    .dropdown {
      top: 30px !important;
    }
  }

  .activate {
    color: $green;
    line-height: 12px;
  }

  .freeze {
    color: $gray-word;
    line-height: 12px;
  }

  img {
    position: relative;
    vertical-align: top;
    top: 21px;
    margin-left: 4px;
  }
}

.remarks {
  a {
    float: left;
  }

  input {
    width: 78%;
    height: 30px;
    padding: 0 3px;
    border: 1px solid transparent;
    line-height: normal;
  }

  input:focus {
    border: 1px solid rgb(199, 198, 198);
  }
}

.operation {
  a {
    color: $darkBlue;
  }
}
</style>
